import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PropTypes from "prop-types";
import React from "react";

export default function MultiOptionsSwitch({ options, onChange, value, disabled = false, styles = {}, context }) {
    const btnstyle = styles ? styles : {};

    return (
        <ButtonGroup size="small" style={{ width: "100%" }} aria-label="small outlined button group">
            {options.map((op) => {
                const onclick = () => {
                    if (!disabled) onChange(op.value);
                };
                const _props = op.value === value ? { color: "secondary", variant: "contained" } : {};
                return (
                    <Button
                        key={op.value}
                        size={"small"}
                        style={btnstyle}
                        onClick={onclick}
                        data-testid={`option-${op.label}-${context}`}
                        {..._props}
                    >
                        {op.label}
                    </Button>
                );
            })}
        </ButtonGroup>
    );
}

MultiOptionsSwitch.propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    styles: PropTypes.object,
    disabled: PropTypes.bool,
    context: PropTypes.string,
};

